import { getService } from 'reducers/service';
import ServiceName from '../../shared/constants/serviceName';

export const getPeopleCredentials = async (ptsPersonID) => {
  const service = getService(ServiceName.RecordPersonCredentials);
  const response = await service.find({
    query: {
      ptsPersonID,
      IsDeleted: false,
      $sort: { Created: -1 },
    },
  });
  return response?.data || response || [];
};

export const getPersonCredential = async (ptsCredentialID) => {
  const response = await getService(ServiceName.RecordPersonCredentials).get(ptsCredentialID);
  return response?.data || response;
};

export const createPersonCredential = async (payload) => {
  const service = getService(ServiceName.RecordPersonCredentials);
  const response = await service.create(payload);
  return response?.data || response;
};

export const editPersonCredential = async (ptsCredentialID, payload) => {
  const service = getService(ServiceName.RecordPersonCredentials);
  const response = await service.patch(ptsCredentialID, payload);
  return response?.data || response;
};

export const deletePersonCredential = async (ptsCredentialID) => {
  const service = getService(ServiceName.RecordPersonCredentials);
  const response = await service.remove(ptsCredentialID);
  return response?.data || response;
};
